import { createContext, useContext, useEffect, useState } from "react";
import { api, setAuthToken, clearAuthToken } from "@/lib/api";

const AuthContext = createContext(null);

const TOKEN_KEY = "faith_athletic_token";

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) {
      setUser(false);
      setLoading(false);
      return;
    }
    setAuthToken(token);
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        clearAuthToken();
        localStorage.removeItem(TOKEN_KEY);
        setUser(false);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    const { access_token, ...rest } = r.data;
    if (access_token) {
      localStorage.setItem(TOKEN_KEY, access_token);
      setAuthToken(access_token);
    }
    setUser(rest);
    return rest;
  };

  const register = async (email, password, name) => {
    const r = await api.post("/auth/register", { email, password, name });
    const { access_token, ...rest } = r.data;
    if (access_token) {
      localStorage.setItem(TOKEN_KEY, access_token);
      setAuthToken(access_token);
    }
    setUser(rest);
    return rest;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      // ignore
    }
    localStorage.removeItem(TOKEN_KEY);
    clearAuthToken();
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used inside AuthProvider");
  return ctx;
};

export const formatApiError = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};
